(ns app.front.view.property.v2.workspace-reassign.events
  (:require [app.front.entities :as entities]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-db ::toggle-selection
  (fn [db [_ selected? workspace-id]]
    (update-in db [::state :selected] (fnil (if selected? conj disj) #{}) workspace-id)))

(rf/reg-event-db ::set-selection
  (fn [db [_ workspace-ids]]
    (assoc-in db [::state :selected] (set workspace-ids))))

(rf/reg-event-db ::open-reassign-modal
  (fn [db [_ property-id workspace-ids]]
    (assoc-in db [::state :reassigning] {:for-property-id property-id
                                         :workspace-ids   (vec workspace-ids)})))

(rf/reg-event-db ::close-reassign-modal
  (fn [db _]
    (p/dissoc-in db [::state :reassigning])))

(rf/reg-event-db ::set-destination
  (fn [db [_ destination]]
    (assoc-in db [::state :reassigning :destination-property-id] (:entity-id destination))))

(rf/reg-event-fx ::reassign
  (fn [{:keys [db]} _]
    (let [{:keys [for-property-id destination-property-id workspace-ids]}
          (get-in db [::state :reassigning])]
      ;; The dialog stays open until the command succeeds, so a rejected reassign keeps the chosen
      ;; destination around to correct instead of dropping it.
      {:db           (assoc-in db [::state :reassigning :submitting?] true)
       :comm/command {:command          :property/reassign-workspaces
                      :data             {:source-property-id for-property-id
                                         :target-property-id destination-property-id
                                         :workspace-ids      workspace-ids}
                      :on-success       [::reassign.success]
                      ;; Runs on every outcome. Unlike `:on-bad-request`/`:on-done`, it does not
                      ;; suppress comm's default error toast that surfaces `:error/property-reassign-*`.
                      :finally-dispatch [::reassign.done]
                      :notify           {:success :property-view/workspaces-reassigned}}})))

(rf/reg-event-fx ::reassign.success
  (fn [{:keys [db]} [_ status changes]]
    ;; Applying the tx changes leaves the property page's edit mode alone, so the section stays
    ;; open by itself and there is nothing to restore here.
    {:db       (-> db
                   (p/dissoc-in [::state :reassigning])
                   (assoc-in [::state :selected] #{}))
     :dispatch [::entities/apply-changes status changes]}))

(rf/reg-event-db ::reassign.done
  (fn [db _]
    (p/dissoc-in db [::state :reassigning :submitting?])))
